




















import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { BitmexModule } from '@/store/modules/bitmex';
import MarketDataCard from './MarketDataCard.vue';


@Component({
  name: 'BitMexFundingRate',
  components: {
    MarketDataCard,
  },
  filters: {
    toPercent(value: number) {
      if (!value) {
        return '';
      }
      return Math.floor(value * 100 * 10000) / 10000 + '%';
    },
  },
})
export default class BitMexFundingRate extends Vue {
  public fundingTimeLeft = -1;
  public formatedFundingTimeLeft = '';
  get loaded() {
    return BitmexModule.fundingTimestamp > 0;
  }
  get fundingRate() {
    return BitmexModule.fundingRate;
  }
  get indicativeFundingRate() {
    return BitmexModule.indicativeFundingRate;
  }
  get fundingRateClass() {
    return {
      'title': true,
      'red--text': BitmexModule.fundingRate >= 0.002,
      'green--text': BitmexModule.fundingRate <= -0.002,
    };
  }
  get indicativeFundingRateClass() {
    return {
      'ml-2': true,
      'body-2': true,
      'red--text': BitmexModule.indicativeFundingRate >= 0.002,
      'green--text': BitmexModule.indicativeFundingRate <= -0.002,
    };
  }
  get alarmIconClass() {
    const isAnimation = this.fundingTimeLeft < 60000;
    return {
      'animated': isAnimation,
      'tada': isAnimation,
      'infinite': isAnimation,
      'orange--text': isAnimation,
    };
  }
  public mounted() {
    const setFormatedFundingTimeLeft = () => {
      // fundingTimestampは締め切りの時間のためプラス1000（1秒）する
      this.fundingTimeLeft =
        BitmexModule.fundingTimestamp + 1000 - new Date().getTime();
      if (this.fundingTimeLeft < 0) {
        this.formatedFundingTimeLeft = 'Loading...';
      } else {
        this.formatedFundingTimeLeft = moment(this.fundingTimeLeft)
          .utcOffset('+0000')
          .format('HH:mm:ss');
      }
    };
    setFormatedFundingTimeLeft();
    setInterval(() => {
      if (this.loaded) {
        setFormatedFundingTimeLeft();
      }
    }, 300);
  }
}
